import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
import { differenceInHours } from 'date-fns';

import { parseISO, addHours, isAfter } from 'date-fns';

const ConfirmUnsubscribeDialog = ({ open, onClose, onConfirm, player, training }) => {
  const trainingDateTime = parseISO(
    `${training?.day.replace(/"/g, '')}T${training?.start_time.replace(/"/g, '')}`,
  );

  // Добавляем 8 часов к текущему времени
  const cancelationDeadline = addHours(new Date(), 8);

  const canRefundVisit = isAfter(trainingDateTime, cancelationDeadline);

  return (
    <Dialog
      open={open}
      onClose={onClose}
    >
      <DialogTitle>Подтверждение отмены записи</DialogTitle>
      <DialogContent>
        <Typography>
          Вы уверены, что хотите отменить запись для игрока <b>{player?.name}</b>?
        </Typography>
        {!canRefundVisit ? (
          <Typography
            color='error'
            sx={{ marginTop: 2 }}
          >
            Внимание: Отмена менее чем за 8 часов до начала тренировки. <br></br>Возврат посещения
            невозможен, если не осталось бесплатных отмен в абонменте.
          </Typography>
        ) : (
          <Typography sx={{ marginTop: 2 }}>
            Посещение вернется, так как до тренировки осталось более 8 часов.
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Отмена</Button>
        <Button
          onClick={onConfirm}
          color='error'
          variant='contained'
        >
          Подтвердить
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmUnsubscribeDialog;
